export const getUser = state => state.user.info || {};
export const isUserFetching = state => state.user.isFetching;
export const isUserFetched = state => state.user.hasFetched;
export const isAuthenticated = state => !!getUser(state).email;
export const shouldLoadUser = state =>
  !isAuthenticated(state) || !isUserFetched(state);
export const sessionId = state => getUser(state).sessionId;
export const getUserRole = state =>
  getUser(state).redirectData && getUser(state).redirectData.role;
export const isLearner = state => getUserRole(state) === "learner";
export const isInstructor = state => getUserRole(state) === "instructor";
export const hasAcceptedTOU = state => getUser(state).eulaAccepted;
export const isReferenceUser = state => getUser(state).ssoOnly;
export const isSsoSession = state => getUser(state).ssoSession;
export const getUserEmail = state => getUser(state).email;
export const isEmailLocked = state => getUser(state).emailLocked;
export const isResettingPassword = state => state.user.resettingPassword;
export const isCreatingUser = state => state.user.creatingNewUser;
export const getEmailStatus = (state, email) =>
  (state.user.emailStatus || {})[email] || {};
export const isCheckingEmailExists = (state, email) =>
  getEmailStatus(state, email).isFetching;
export const getActivationStatus = (state, email) =>
  (state.user.activationStatus || {})[email] || {};
export const isResendingActivationEmail = (state, email) =>
  getActivationStatus(state, email).isFetching;
export const isRequestingEmailVerification = state =>
  state.user.emailVerificationRequesting;
export const emailIsVerified = state =>
  getUser(state).emailVerificationCompleted;
export const requiresEmailVerification = state =>
  getUser(state).emailVerificationRequired;
export const isMergingUser = state => state.user.mergingAccounts;
export const shouldResetPassword = state => !isResettingPassword(state);
export const shouldMergeUser = state => !isMergingUser(state);
